/**
 * Created by mgoria on 1/29/16.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AbstractEvent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _deepCore = require('deep-core');

var _deepCore2 = _interopRequireDefault(_deepCore);

var _joi = require('joi');

var _joi2 = _interopRequireDefault(_joi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Abstract RUM event
 */
let AbstractEvent = exports.AbstractEvent = function (_Core$OOP$Interface) {
  _inherits(AbstractEvent, _Core$OOP$Interface);

  /**
   * @param {Object} kernel
   * @param {Object} rawData
   */
  function AbstractEvent(kernel, rawData) {
    _classCallCheck(this, AbstractEvent);

    var _this = _possibleConstructorReturn(this, (AbstractEvent.__proto__ || Object.getPrototypeOf(AbstractEvent)).call(this, ['toJSON', 'getValidationSchema', 'getEventLevel']));

    _this._kernel = kernel;
    _this._rawData = rawData;
    _this._data = _this._enrichWithContextData(rawData);

    _this._validationError = null;
    return _this;
  }

  /**
   * @returns {String}
   */


  _createClass(AbstractEvent, [{
    key: 'isValid',


    /**
     * @returns {Boolean}
     */
    value: function isValid() {
      let result = this.validate();

      return result.error ? false : true;
    }

    /**
     * @returns {Object}
     */

  }, {
    key: 'validate',
    value: function validate() {
      let result = _joi2.default.validate(this._data, this.getValidationSchema(), {
        stripUnknown: true,
        convert: true,
        abortEarly: false
      });

      if (result.error) {
        this._validationError = result.error;
      } else {
        this._data = result.value;
      }

      return result;
    }

    /**
     * @returns {Object|null}
     */

  }, {
    key: '_enrichWithContextData',


    /**
     * @param {Object} event
     * @returns {Object}
     * @private
     */
    value: function _enrichWithContextData(event) {
      event.eventLevel = this.getEventLevel();
      event.time = event.time || new Date().getTime();
      event.metadata = event.metadata || {};

      if (this._kernel.isBackend) {
        let runtimeContext = this._kernel.runtimeContext;

        event.depthLevel = runtimeContext.getDeepFrameworkOption('lambdaDepthLevel') || 0;
        event.mainRequestId = runtimeContext.getDeepFrameworkOption('mainRequestId') || runtimeContext.awsRequestId;
        event.context = AbstractEvent.BACKEND_CONTEXT;
        event.memoryUsage = process.memoryUsage();
        event.environment = {}; // @todo - find a way to get Lambda container info (id, OS, etc)

        event.requestId = event.requestId || runtimeContext.awsRequestId;

        // identity context is not passed if lambda is called directly by another lambda not through API Gateway
        event.identityId = runtimeContext.identity && runtimeContext.identity.cognitoIdentityId ? runtimeContext.identity.cognitoIdentityId : 'system';
      } else {
        event.context = AbstractEvent.FRONTEND_CONTEXT;
        event.memoryUsage = window.performance && window.performance.memory ? window.performance.memory : {};
        event.environment = {
          userAgent: navigator ? navigator.userAgent : ''
        };

        let securityToken = this._kernel.get('security').token;
        event.identityId = securityToken && securityToken.identityId ? securityToken.identityId : 'anonymous';
      }

      return event;
    }
  }, {
    key: 'validationError',
    get: function get() {
      return this._validationError;
    }
  }], [{
    key: 'FRAMEWORK_EVENT_LEVEL',
    get: function get() {
      return 'Framework';
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'FRONTEND_EVENT_LEVEL',
    get: function get() {
      return 'Frontend';
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'BACKEND_CONTEXT',
    get: function get() {
      return 'Backend';
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'FRONTEND_CONTEXT',
    get: function get() {
      return 'Frontend';
    }

    /**
     * @returns {String[]}
     */

  }, {
    key: 'CONTEXTS',
    get: function get() {
      return [AbstractEvent.BACKEND_CONTEXT, AbstractEvent.FRONTEND_CONTEXT];
    }

    /**
     * @returns {String[]}
     */

  }, {
    key: 'SERVICES',
    get: function get() {
      return ['deep-asset', 'deep-cache', 'deep-core', 'deep-db', 'deep-event', 'deep-fs', 'deep-kernel', 'deep-log', 'deep-notification', 'deep-resource', 'deep-security', 'deep-validation'];
    }

    /**
     * @returns {String[]}
     */

  }, {
    key: 'RESOURCE_TYPES',
    get: function get() {
      return ['Browser', 'Lambda', 'S3', 'DynamoDB', 'CloudFront', 'InMemory', 'LocalStorage', 'Redis', 'S3FS', 'Cognito'];
    }
  }]);

  return AbstractEvent;
}(_deepCore2.default.OOP.Interface);


//////////////////
// WEBPACK FOOTER
// ../~/deep-log/lib.compiled/Driver/RUM/AbstractEvent.js
// module id = 94
// module chunks = 0